import superagent from 'superagent'
import { RequestControl, RequestCommonResponse } from '../actions'

const actions = {
  // 评价等级获取
  userEvaluate ({ commit, rootState }, params) {
    return new Promise(function (resolve, reject) {
      params = RequestControl(rootState, params)
      superagent
      .post('/index.php/charter/mine/get_level_evaluate')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          RequestCommonResponse(rootState, _res, reject)
        }
      })
    })
  },
  // 提交评价
  submitEvaluate ({ commit, rootState }, params) {
    return new Promise(function (resolve, reject) {
      params = RequestControl(rootState, params)
      superagent
      .post('/index.php/charter/mine/submit_order_evaluate')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          RequestCommonResponse(rootState, _res, reject)
        }
      })
    })
  },
  // 获取用户评价信息
  userSelfEvaluate ({ commit, rootState }, params) {
    return new Promise(function (resolve, reject) {
      params = RequestControl(rootState, params)
      superagent
      .post('/index.php/charter/mine/get_order_evaluate')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res = JSON.parse(res.text)
        if (_res.result === '0000') {
          resolve(_res)
        } else {
          RequestCommonResponse(rootState, _res, reject)
        }
      })
    })
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/rater.js